import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconOpenInNew = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M14 4h6v6' />
      <path d='M20 4 11 13' />
      <path d='M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5' />
    </g>
  </SDIcon>
)

export default IconOpenInNew
